import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import env from '../env';
const stripePromise = loadStripe(env.STRIPE_PUBLISHABLE_KEY || '');

const appearance = {
  theme: 'flat', // Valid values: 'flat', 'stripe', 'night', undefined
  variables: {
    colorText: '#000000', // Global text color
    fontFamily: '"Inter", sans-serif', // Font family
    fontSize: '15px',
  },
  rules: {
    '.Label': {
      color: '#ffffff',
      padding:'4px 0px 1px 0px',
    },
    '.Input':{
      padding:'8px',
      height:'30px',
      borderRadius:'5px',
    }
  },
} as const; // Explicitly assert this as a const to match the Appearance type

const StripeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Elements stripe={stripePromise} options={{ appearance: appearance as any }}>
    {children}
  </Elements>
);

export default StripeProvider;
